<template>
    <div v-if="browserInvalid" class="browser-check-bar">
        <span>{{translate('invalid_browser')}}</span>
    </div>
</template>

<script>
    export default {
        name: 'BrowserCheck',

        data() {
            return {
                browserInvalid: false
            }
        },

        created() {
            this.checkBrowser();
        },

        methods: {
            checkBrowser() {
                if(this.getBrowser().name !== 'Chrome') {
                    this.browserInvalid = true;
                    return false;
                } else {
                    this.browserInvalid = false;
                    return true;
                }
            },

            getBrowser() {
                var ua = navigator.userAgent, tem,
                    M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
                if (/trident/i.test(M[1])) {
                    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                    return {name: 'IE', version: (tem[1] || '')};
                }
                if (M[1] === 'Chrome') {
                    tem = ua.match(/\bOPR|Edge\/(\d+)/)
                    if (tem != null) {
                        return {name: 'Opera', version: tem[1]};
                    }
                }
                M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
                if ((tem = ua.match(/version\/(\d+)/i)) != null) {
                    M.splice(1, 1, tem[1]);
                }
                return {
                    name: M[0],
                    version: M[1]
                };
            },

            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                };

                this.$store.commit(arg);

                return arg.out;
            },
        },

    }
</script>